export class Nav{
  title: string;
  roles: any;
  options: any;
}
